/*@flow*/
import type { Action } from '../types';
import type { IntegrationState } from './types';
import * as I from 'immutable';
import setIn from 'lib/setIn';

type StateRecord = I.RecordOf<IntegrationState>;

export default (state: StateRecord, action: Action) => {
  const { type, payload } = action;
  let newState = state;

  switch (type) {
    // TODO: create an ID for the integration
    case 'NEW':
      // $FlowFixMe[incompatible-call]
      newState = newState.update((v) => {
        return v
          .set('id', '')
          .set('resourceName', '')
          .set('url', '')
          .set('name', '')
          .set('fields', [])
          .set('navMode', 'NEW_INTEGRATION');
      });
      break;
    case 'EDIT':
      if (payload) {
        newState = newState
          .set('id', payload.id)
          .set('resourceName', payload.resourceName)
          .set('url', payload.url)
          .set('name', payload.name)
          .set('fields', payload.fields)
          .set('navMode', 'EDIT_INTEGRATION');
      }
      break;
    case 'FINISH':
      newState = (newState: any)
        .set('navMode', 'LANDING')
        .set('step', 1)
        .set('fields', [])
        .set('resourceName', '')
        .set('url', '')
        .set('name', '')
        .set('id', '');
      break;
    case 'SET_RECORD':
      if (payload) {
        newState = setIn(newState)(payload);
      }
      break;
    default:
      throw new Error('Unrecognized action `' + type + '`');
  }
  return newState;
};
